import * as THREE from 'three';
import { G, K_BEV, mesh } from '../render/scene';
import { MAT_P, coreGlow } from '../render/materials';
import { bevel, joint, mark, plate, rib, seam } from './mech-kit';
/* ============================================================
   駕艙 / 感應器 / 掛架（1:1 移植自 mech_sample_ani.html）
   ============================================================ */

/* 駕艙：頭縮小到 0.50 高 → 7.4 頭身。頭小則機體顯大。 */
export function buildCockpit(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['cock-armor', 'cock-esc', 'cock-std']);
  g.add(mesh(G.cyl, MAT_P.trim, [0.22, 0.18, 0.22], [0, 0.02, 0]));                // 頸

  if (shape === 'cock-armor') {
    g.add(bevel(MAT_P.dark, 0.52, 0.36, 0.56, [0, 0.22, 0]));
    g.add(plate(MAT_P.armor, 0.62, 0.26, 0.24, [0, 0.36, 0.11], -0.42));
    g.add(rib(MAT_P.armor, 0.64, 0.07, 0.07, [0, 0.46, 0.18], -0.42));           // 額緣亮線
    g.add(mesh(G.box, MAT_P.visor, [0.26, 0.04, 0.07], [0, 0.20, 0.27]));       // 窄視窗
    g.add(seam(0.44, 0.04, 0.06, [0, 0.12, 0.26]));
    g.add(plate(MAT_P.armor, 0.13, 0.32, 0.46, [0.27, 0.20, 0], 0.08));
    g.add(plate(MAT_P.armor, 0.13, 0.32, 0.46, [-0.27, 0.20, 0], 0.08));
    g.add(plate(MAT_P.armor, 0.54, 0.14, 0.48, [0, 0.42, -0.06], -0.14));
    g.add(bevel(MAT_P.trim, 0.32, 0.24, 0.24, [0, 0.24, -0.32]));                 // 後配重

  } else if (shape === 'cock-esc') {
    g.add(mesh(G.oct, MAT_P.dark, [0.62, 0.54, 0.62], [0, 0.24, 0]));           // 八面體莢艙
    g.add(mesh(G.box, MAT_P.visor, [0.30, 0.08, 0.11], [0, 0.24, 0.23]));
    g.add(mesh(G.cone, MAT_P.armor, [0.28, 0.38, 0.28], [0, 0.54, -0.02]));      // 逃生錐
    g.add(mesh(G.cone, P.glow, [0.12, 0.14, 0.12], [0, 0.72, -0.02]));
    g.add(mesh(G.tor, MAT_P.trim, [0.68, 0.68, 0.17], [0, 0.24, 0], [Math.PI / 2, 0, 0]));
    g.add(rib(MAT_P.armor, 0.07, 0.07, 0.56, [0, 0.42, 0], 0, 0, 0));
    g.add(plate(MAT_P.armor, 0.24, 0.28, 0.14, [0.23, 0.22, 0.19], 0, 0.50));
    g.add(plate(MAT_P.armor, 0.24, 0.28, 0.14, [-0.23, 0.22, 0.19], 0, -0.50));

  } else {  /* cock-std：不是臉，是感測莢艙 —— 單顆偏心主鏡是 AC 的頭部語彙 */
    g.add(bevel(MAT_P.dark, 0.44, 0.30, 0.48, [0, 0.20, 0]));                     // 莢艙本體
    g.add(plate(MAT_P.armor, 0.46, 0.15, 0.34, [0.02, 0.35, -0.02], -0.16, 0, -0.12));
    g.add(rib(MAT_P.armor, 0.48, 0.07, 0.07, [0.02, 0.43, 0.12], -0.30, 0, -0.12));
    g.add(mesh(G.cyl, MAT_P.visor, [0.19, 0.11, 0.19], [-0.09, 0.20, 0.23], [Math.PI / 2, 0, 0])); // 主鏡（偏心）
    g.add(mesh(G.tor, MAT_P.trim, [0.28, 0.28, 0.13], [-0.09, 0.20, 0.23]));   // 鏡圈
    g.add(mesh(G.box, MAT_P.visor, [0.08, 0.05, 0.07], [0.13, 0.25, 0.23]));   // 副感測群
    g.add(mesh(G.box, MAT_P.visor, [0.08, 0.05, 0.07], [0.13, 0.16, 0.23]));
    g.add(plate(MAT_P.armor, 0.09, 0.26, 0.40, [0.24, 0.19, 0.00], 0.10, 0, 0.14));
    g.add(seam(0.34, 0.04, 0.06, [0.02, 0.06, 0.22]));                        // 下緣散熱縫
    g.add(bevel(MAT_P.trim, 0.24, 0.11, 0.24, [0, 0.04, 0.10]));
  }
  return g;
}

/* 感應器：掛在頭部 -X 側，刻意不對稱 */
export function buildSensor(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['sen-wide', 'sen-tac', 'sen-luck', 'sen-std']);
  g.add(bevel(MAT_P.trim, 0.15, 0.13, 0.17, [0, 0, 0]));

  if (shape === 'sen-wide') {
    g.add(mesh(G.box, MAT_P.dark, [0.20, 0.07, 0.09], [-0.09, 0.02, 0]));
    g.add(plate(MAT_P.armor, 0.30, 0.05, 0.34, [-0.21, 0.10, -0.02], 0.12, 0.24));
    g.add(plate(MAT_P.armor, 0.25, 0.05, 0.28, [-0.19, 0.21, -0.04], 0.12, 0.24));
    g.add(plate(MAT_P.armor, 0.20, 0.05, 0.21, [-0.17, 0.31, -0.06], 0.12, 0.24));
    g.add(rib(MAT_P.armor, 0.32, 0.04, 0.04, [-0.21, 0.13, 0.13], 0.12, 0.24));  // 板緣亮線
    g.add(mesh(G.box, P.glow, [0.18, 0.03, 0.04], [-0.19, 0.23, 0.08]));
    g.add(mesh(G.cyl, MAT_P.trim, [0.05, 0.32, 0.05], [-0.12, 0.19, -0.07]));

  } else if (shape === 'sen-luck') {
    /* 機率演算單元：一顆懸在環裡的八面體（骰）＋兩片運算鰭。
       三個感應器在俯視鏡頭下只有幾十像素，要靠**輪廓**分辨不是靠細節 ——
       sen-wide 是層疊板、sen-tac 是長桿、這個是「環包球」。 */
    g.add(mesh(G.box, MAT_P.dark, [0.16, 0.15, 0.11], [-0.07, 0.09, 0]));
    g.add(mesh(G.tor, MAT_P.trim, [0.27, 0.27, 0.12], [-0.10, 0.33, -0.02], [0, 0.5, 0.34]));
    g.add(mesh(G.oct, P.glow, [0.13, 0.13, 0.13], [-0.10, 0.33, -0.02]));
    g.add(plate(MAT_P.armor, 0.21, 0.04, 0.19, [-0.14, 0.17, -0.03], 0.10, 0.18));
    g.add(plate(MAT_P.armor, 0.17, 0.04, 0.15, [-0.13, 0.23, -0.03], 0.10, 0.18));
    g.add(rib(MAT_P.armor, 0.04, 0.21, 0.04, [-0.02, 0.15, -0.08], 0.20));

  } else if (shape === 'sen-tac') {
    g.add(mesh(G.cyl, MAT_P.dark, [0.09, 0.42, 0.09], [-0.04, 0.26, -0.02], [0, 0, 0.10]));
    g.add(bevel(MAT_P.armor, 0.15, 0.11, 0.15, [-0.07, 0.51, -0.02]));
    g.add(mesh(G.cyl, MAT_P.armor, [0.05, 0.40, 0.05], [-0.11, 0.75, -0.02], [0, 0, 0.10]));
    g.add(mesh(G.cone, MAT_P.trim, [0.07, 0.18, 0.07], [-0.15, 1.02, -0.02]));
    g.add(mesh(G.oct, P.glow, [0.09, 0.09, 0.09], [-0.07, 0.51, 0.10]));
    g.add(mesh(G.tor, MAT_P.trim, [0.25, 0.25, 0.10], [-0.06, 0.38, -0.02], [Math.PI / 2, 0, 0]));
    g.add(rib(MAT_P.armor, 0.04, 0.30, 0.04, [-0.02, 0.30, -0.09], 0.24));
    g.add(plate(MAT_P.armor, 0.05, 0.22, 0.13, [0.02, 0.19, -0.09], 0.30));

  } else {  /* sen-std */
    g.add(mesh(G.box, MAT_P.dark, [0.09, 0.09, 0.20], [0, 0.03, -0.09]));
    g.add(mesh(G.cyl, MAT_P.armor, [0.05, 0.44, 0.05], [-0.06, 0.24, -0.02], [0, 0, 0.30]));
    g.add(mesh(G.oct, P.glow, [0.09, 0.09, 0.09], [-0.14, 0.46, -0.02]));   // 感應珠
    g.add(mesh(G.cyl, MAT_P.armor, [0.04, 0.24, 0.04], [-0.02, 0.13, -0.13], [0.40, 0, 0.16]));
    g.add(mesh(G.oct, MAT_P.trim, [0.07, 0.07, 0.07], [-0.06, 0.23, -0.20]));
    g.add(rib(MAT_P.armor, 0.04, 0.16, 0.04, [-0.02, 0.09, 0.05], -0.30));
  }
  return g;
}

/* 掛架 PYLON：左肩（+X）。肩甲上揚外張、上緣加亮線 —— 氣場的主要來源。 */
export function buildPylon(shape, P?) {
  P = P || { glow: coreGlow('core-std') };
  var g = new THREE.Group();
  mark(g, shape, ['pyl-weapon', 'pyl-passive', 'pyl-std']);
  g.add(joint(0.21, [0, 0, 0]));
  g.add(bevel(MAT_P.dark, 0.42, 0.46, 0.56, [0.12, -0.02, 0]));

  if (shape === 'pyl-weapon') {
    g.add(bevel(MAT_P.dark, 0.54, 0.62, 0.64, [0.44, 0.16, 0]));                  // 飛彈巢
    var d = [[-0.13, -0.14], [0.13, -0.14], [-0.13, 0.14], [0.13, 0.14]];
    for (var i = 0; i < 4; i++)
      g.add(mesh(G.cyl, MAT_P.trim, [0.21, 0.36, 0.21],
        [0.44 + d[i][0], 0.16 + d[i][1], 0.34], [Math.PI / 2, 0, 0]));
    g.add(plate(MAT_P.armor, 0.66, 0.18, 0.60, [0.44, 0.54, 0.02], -0.30, 0.10, -0.26)); // 上掀蓋（上揚）
    g.add(rib(MAT_P.armor, 0.70, 0.08, 0.08, [0.44, 0.63, 0.16], -0.30, 0.10, -0.26)); // 上緣亮線
    g.add(seam(0.06, 0.60, 0.10, [0.44, 0.16, 0.36]));
    g.add(mesh(G.box, P.glow, [0.44, 0.04, 0.04], [0.44, -0.16, 0.30]));

  } else if (shape === 'pyl-passive') {
    g.add(mesh(G.cyl, MAT_P.armor, [0.33, 0.82, 0.33], [0.44, 0.14, 0.16], [0.10, 0, 0.10]));
    g.add(mesh(G.cyl, MAT_P.armor, [0.29, 0.68, 0.29], [0.44, 0.04, -0.24], [0.10, 0, 0.10]));
    g.add(mesh(G.tor, MAT_P.trim, [0.43, 0.43, 0.15], [0.45, 0.34, 0.16], [Math.PI / 2, 0, 0.10]));
    g.add(mesh(G.tor, MAT_P.trim, [0.39, 0.39, 0.15], [0.45, 0.25, -0.24], [Math.PI / 2, 0, 0.10]));
    g.add(rib(MAT_P.armor, 0.07, 0.80, 0.07, [0.58, 0.14, 0.16], 0, 0, 0.10));     // 莢艙外緣亮線
    g.add(plate(MAT_P.armor, 0.16, 0.44, 0.72, [0.42, 0.50, -0.04], 0.10, 0.16, -0.34)); // 上蓋（上揚）
    g.add(mesh(G.box, MAT_P.trim, [0.34, 0.10, 0.52], [0.44, -0.32, -0.04]));
    g.add(mesh(G.oct, P.glow, [0.13, 0.13, 0.13], [0.44, 0.58, 0.16]));

  } else {  /* pyl-std */
    g.add(plate(MAT_P.armor, 0.22, 0.88, 0.94, [0.40, 0.20, 0], 0.10, 0.18, -0.22)); // 主盾板
    g.add(plate(MAT_P.armor, 0.16, 0.58, 0.66, [0.53, 0.30, 0.06], 0.10, 0.18, -0.22)); // 第二層
    g.add(rib(MAT_P.armor, 0.10, 0.10, 0.94, [0.44, 0.62, 0], 0.10, 0.18, -0.22)); // 上緣亮線
    g.add(seam(0.06, 0.82, 0.10, [0.44, 0.18, 0.36], 0.10, 0.18, -0.22));
    g.add(plate(MAT_P.armor, 0.14, 0.34, 0.50, [0.46, -0.28, 0], 0, 0.18, 0.30));  // 下擺
    g.add(mesh(G.box, P.glow, [0.05, 0.22, 0.05], [0.52, 0.34, 0.16]));
  }
  return g;
}
